(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["elysarne-pdp-videos"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elysarne-pdp-videos')) {
    class ElysarnePdpVideos extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.querySelectorAll('video').forEach((video) => {
          const toggle = video.parentElement.querySelector('.elysarne-pdp-videos__toggle');
          const error = video.parentElement.querySelector('.elysarne-pdp-videos__error');
          const sync = () => {
            const playing = !video.paused && !video.ended;
            toggle.toggleAttribute('data-playing', playing);
            toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
          };
          const showError = () => { error.hidden = false; sync(); };
          toggle.hidden = false;
          toggle.addEventListener('click', async () => {
            error.hidden = true;
            if (video.paused || video.ended) {
              try {
                await video.play();
              } catch (playError) {
                if (playError?.name !== 'AbortError' && this.isConnected) showError();
              }
            } else {
              video.pause();
            }
            sync();
          }, options);
          video.addEventListener('play', () => {
            document.querySelectorAll('elysarne-pdp-videos video, elysarne-ugc video').forEach((other) => {
              if (other !== video) other.pause();
            });
            error.hidden = true;
            sync();
          }, options);
          video.addEventListener('pause', sync, options);
          video.addEventListener('ended', sync, options);
          video.addEventListener('error', showError, options);
          sync();
        });
      }
      disconnectedCallback() {
        this.querySelectorAll('video').forEach((video) => video.pause());
        this.abortController?.abort();
      }
    }
    customElements.define('elysarne-pdp-videos', ElysarnePdpVideos);
  }
  } catch(e) { console.error(e); }
})();

})();
